var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgfilter4Advanced = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M32.25 119.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M32.25 116c.248 0 .451.221.451.493v2.172c0 .272-.203.493-.452.493s-.452-.221-.452-.493v-2.172c0-.272.203-.493.452-.493M29.452 118.986h1.788c.25 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M33.258 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M252.249 23.8c.249 0 .452.222.452.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M252.249 20c.249 0 .452.221.452.493v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.493.452-.493M249.452 22.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M253.258 22.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M22 28.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 42.667,
  height: 64,
  x: 204,
  y: 31,
  fill: "#C1E2DA",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 34.54,
  height: 34.54,
  x: 208.063,
  y: 34.049,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 29.46,
  height: 3.048,
  x: 208.063,
  y: 72.647,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 13.885,
  height: 3.085,
  x: 208.063,
  y: 78.824,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 20.056,
  height: 3.085,
  x: 208.063,
  y: 83.449,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 34.667,
  height: 52,
  x: 163,
  y: 49,
  fill: "#C1E2DA",
  rx: 2
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 28.064,
  height: 28.064,
  x: 166.302,
  y: 51.477,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 23.936,
  height: 2.476,
  x: 166.302,
  y: 82.838,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 11.281,
  height: 2.507,
  x: 166.302,
  y: 87.857,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 16.295,
  height: 2.507,
  x: 166.302,
  y: 91.615,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 34.667,
  height: 52,
  x: 126,
  y: 30,
  fill: "#C1E2DA",
  rx: 2
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 28.064,
  height: 28.064,
  x: 129.302,
  y: 32.477,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 23.936,
  height: 2.476,
  x: 129.302,
  y: 63.838,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 11.281,
  height: 2.507,
  x: 129.302,
  y: 68.857,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 16.295,
  height: 2.507,
  x: 129.302,
  y: 72.615,
  fill: "#008060",
  fillOpacity: 0.6,
  rx: 1
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 57.527,
  height: 99,
  x: 42,
  y: 19,
  fill: "#fff",
  rx: 2
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 48.69,
  y: 27.027,
  fill: "#008060",
  rx: 1
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 48.69,
  y: 38.813,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 13.378,
  height: 5.351,
  x: 47.352,
  y: 83.217,
  fill: "#008060",
  rx: 1
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  width: 29.432,
  height: 4.014,
  x: 47.352,
  y: 91.244,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  width: 21.405,
  height: 4.014,
  x: 47.352,
  y: 97.934,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  width: 12.614,
  height: 9.428,
  x: 64.457,
  y: 27.027,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  width: 12.614,
  height: 9.428,
  x: 64.457,
  y: 38.813,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 79.173,
  y: 27.027,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 79.173,
  y: 38.813,
  fill: "#008060",
  opacity: 0.4,
  rx: 1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#008060",
  clipPath: "url(#img_filter4_advanced_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 51.315,
  cy: 62.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.039,
  cy: 62.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70.763,
  cy: 62.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80.487,
  cy: 62.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.211,
  cy: 62.012,
  r: 3
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#008060",
  clipPath: "url(#img_filter4_advanced_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 51.315,
  cy: 72.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.039,
  cy: 72.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70.763,
  cy: 72.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80.487,
  cy: 72.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.211,
  cy: 72.686,
  r: 3
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M71.909 118.171a.75.75 0 0 1 1.183-.923zm56.804-4.008-.741.113zm-17.213 3.546-.699.271zm104.47-20.24a.75.75 0 0 1 1.06 0l4.773 4.774a.749.749 0 1 1-1.061 1.06l-4.242-4.242-4.243 4.242a.749.749 0 1 1-1.06-1.06zM73.092 117.249a25 25 0 0 0 2.795 3.031l-1.013 1.106a26 26 0 0 1-2.965-3.214zm4.37 4.353c2.218 1.705 4.662 2.964 7.246 3.851l-.486 1.418c-2.724-.934-5.315-2.267-7.674-4.08zm9.226 4.451c2.65.702 5.418 1.049 8.218 1.11l-.033 1.5c-2.9-.064-5.789-.423-8.57-1.16zm10.304 1.104c2.793-.076 5.59-.416 8.302-.95l.29 1.472c-2.784.548-5.665.899-8.552.977zm10.348-1.393a59 59 0 0 0 7.996-2.499l.549 1.396a60 60 0 0 1-8.201 2.563zm9.929-3.302c2.928-1.283 5.422-2.69 7.276-4.041l.883 1.212c-1.96 1.429-4.554 2.887-7.557 4.203zm8.861-5.323c.699-.638 1.198-1.224 1.503-1.735.309-.518.375-.887.339-1.127l1.483-.225c.109.72-.133 1.448-.534 2.121-.406.68-1.018 1.378-1.78 2.074zm1.842-2.862c-.068-.444-.336-.903-.852-1.358-.517-.455-1.246-.87-2.138-1.215l.541-1.399c.999.386 1.899.881 2.588 1.488.69.608 1.207 1.363 1.344 2.259zm-5.219-3.211c-3.161-.638-6.818-.398-9.023.905l-.763-1.291c2.651-1.568 6.738-1.76 10.083-1.085zm-10.525 2.316c-.57.93-.735 2.23-.028 4.058l-1.399.541c-.829-2.143-.727-3.955.148-5.383zm-.028 4.058a19.4 19.4 0 0 0 1.82 3.573l-1.259.815a21 21 0 0 1-1.96-3.847zm2.994 5.196c1.644 2.043 3.7 3.764 6.1 5.185l-.765 1.29c-2.533-1.5-4.733-3.334-6.503-5.534zm7.895 6.161c2.307 1.151 4.877 2.062 7.655 2.747l-.36 1.456c-2.867-.707-5.544-1.653-7.965-2.861zm9.656 3.195c2.58.521 5.313.862 8.156 1.037l-.092 1.497c-2.903-.178-5.705-.528-8.36-1.064zm10.212 1.134c2.679.089 5.443.037 8.257-.144l.096 1.497c-2.858.184-5.67.236-8.403.146zm10.313-.298c2.709-.232 5.455-.58 8.207-1.033l.244 1.48c-2.789.46-5.573.812-8.323 1.048zm10.248-1.388a119 119 0 0 0 8.084-1.776l.372 1.453a121 121 0 0 1-8.186 1.799zm10.083-2.306a119 119 0 0 0 7.901-2.465l.497 1.416a121 121 0 0 1-8.001 2.495zm9.851-3.169a105 105 0 0 0 7.632-3.172l.631 1.361a107 107 0 0 1-7.741 3.218zm9.504-4.064a81 81 0 0 0 7.221-3.993l.796 1.272a82 82 0 0 1-7.357 4.067zm8.94-5.105c2.423-1.621 4.595-3.317 6.462-5.067l1.026 1.094c-1.936 1.815-4.175 3.561-6.654 5.22zm7.898-6.488c2.054-2.149 3.627-4.357 4.639-6.586l1.366.621c-1.098 2.417-2.781 4.762-4.921 7.002zm5.349-8.44c.4-1.287.607-2.577.607-3.867h1.5c0 1.452-.234 2.893-.675 4.312z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter4_advanced_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.315 58.01H93.21v8.005H48.315z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter4_advanced_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.315 68.684H93.21v8.005H48.315z"
})))));
export { SvgImgfilter4Advanced as ReactComponent };
export default __webpack_public_path__ + "static/media/img.filter4.advanced.0ea4a8fa.svg";